<template>
  <Tabs>
    <TabsHeader tabs-header-class="atb-bg-white">
      <Tab
        v-for="(tab, index) in tabNamesList"
        :key="tab.id"
        :index="index"
        :value="Number(selectedTabIndex)"
        :closable="false"
        @tabClick="() => tabChange(String(tab.id))"
      >
        {{ tab.name }}
      </Tab>
    </TabsHeader>

    <TabsBody>
      <TabPanelItem>
        <component
          :is="currentTabComponent"
          @change-tab="tabChange"
        />
      </TabPanelItem>
    </TabsBody>
  </Tabs>
</template>

<script lang="ts" setup>
  import { TabHeader } from '@/app/shared/types/tab-header.interface';
  import { ref, shallowRef } from 'vue';
  import Tabs from '@atb-ui/eds-vue/src/components/Tabs/Tabs.vue';
  import Tab from '@atb-ui/eds-vue/src/components/Tabs/Tab.vue';
  import TabsHeader from '@atb-ui/eds-vue/src/components/Tabs/TabsHeader.vue';
  import TabsBody from '@atb-ui/eds-vue/src/components/Tabs/TabsBody.vue';
  import TabPanelItem from '@atb-ui/eds-vue/src/components/Tabs/TabPanelItem.vue';
  import Mds from '@/app/features/ams/tools/mds/Mds.vue';
  import Export from '@/app/features/ams/tools/export/Export.vue';
  import Import from '@/app/features/ams/tools/import/Import.vue';
  import ToolsHome from '@/app/features/ams/tools/home/ToolsHome.vue';

  const selectedTabIndex = ref('0');
  const currentTabComponent: any = shallowRef(ToolsHome);

  const tabNamesList: Array<TabHeader> = [
    { id: 0, name: 'Tools Home' },
    { id: 1, name: 'Export' },
    { id: 2, name: 'Import' },
    { id: 3, name: 'Multi Data Sources' },
  ];

  const tabChange = (index: string) => {
    selectedTabIndex.value = index;
    switch (index) {
      case '0':
        currentTabComponent.value = ToolsHome;
        break;
      case '1':
        currentTabComponent.value = Export;
        break;
      case '2':
        currentTabComponent.value = Import;
        break;
      case '3':
        currentTabComponent.value = Mds;
        break;
      default:
        break;
    }
  };
</script>

<style>
  .card-content {
    box-shadow: 0 10px 29px 0 rgba(68, 88, 144, 0.1);
  }
</style>
